var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH } from "./useRequest";
import { useState } from "@max/max";
export function usePredictCityInfo(options) {
    const ctx = useMonitorEngineContext();
    const [predictCityInfoData, setPredictCityInfoData] = useState();
    const { requestStatus, request } = useRequest(API_PATH.QUERY_PREDICT_CITY_INFO);
    function loadPredictCityInfoData() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield request({
                    cityId: options.cityId,
                    locateCityId: options.locateCityId
                });
                if (!res) {
                    throw new Error('获取预测城市信息失败');
                }
                setPredictCityInfoData(res);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.QUERY_PREDICT_CITY_INFO
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.QUERY_PREDICT_CITY_INFO
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
            }
        });
    }
    return {
        loadPredictCityInfoData,
        requestStatus,
        predictCityInfoData
    };
}
